module.exports = __webpack_public_path__ + "static/media/foxshoes.572053cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/foxshoes.png
// module id = 86
// module chunks = 0